var map = {
	"./en/alerts.json": 63285,
	"./en/app.json": 21591,
	"./en/cart.json": 72822,
	"./en/copyright.json": 850,
	"./en/courseCard.json": 38507,
	"./en/courses.json": 45277,
	"./en/home.json": 20081,
	"./en/notFound.json": 19386,
	"./en/popups.json": 33635,
	"./en/recoverPassword.json": 62438,
	"./en/resetPassword.json": 46423,
	"./en/signin.json": 54782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85189;